import React, { useState } from "react";
import "./Login.css";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import axios from "axios";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { storeToken } from "../utils/AuthStorage";

const Login = () => {
    const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");  
    const data = {
      username: formData.username,
      password: formData.password,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/login`,
        data,
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('Login successful:', response.data);
      storeToken(response.data.data.token);
      const { firstName, lastName } = response.data.data.userDetails;
      const initials = `${firstName ? firstName[0] : ""}${lastName ? lastName[0] : ""}`;
      localStorage.setItem("userInitials", initials.toUpperCase());
      toast.success(response?.data?.message ||'Login Successfully' , {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        navigate('/')
    } catch (err) {
        toast.error(err?.response?.data?.message ||'Login Failed' , {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
            });
      console.error('Login failed:', err.response || err.message);
      setError("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
        <ToastContainer />
      <form className="form" onSubmit={handleSubmit}>
        <h2>Login</h2>
        <div className="input-group">
          <label className="label" htmlFor="username">
            Username
          </label>
          <input
            type="text"
            id="username"
            name="username"
            className="input"
            value={formData.username}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="input-group">
          <label className="label" htmlFor="password">
            Password
          </label>
          <div className="password-container">
            <input
              type={passwordVisible ? "text" : "password"}
              id="password"
              name="password"
              className="input"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <span className="eye-icon" onClick={togglePasswordVisibility}>
              {passwordVisible ? <IoEyeOutline /> : <IoEyeOffOutline />}
            </span>
          </div>
        </div>
        
        {error && <p className="error-message">{error}</p>} 
        
        <button type="submit" className="button" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <p className="toggle-text">
          Don't have an account?
          <span
            className="toggle-link" onClick={()=> navigate(`/register`)}
          >
            Register
          </span>
        </p>
      </form>
     
    </div>
  );
};

export default Login;
